import { useServerRequest } from '../api'
import { dispositionKey } from '../keys'
import { useQueries } from '@tanstack/react-query'
import {
  DAY,
  type DispositionData,
  type DispositionGetInput,
  type DispositionGetSuccess,
  type DispositionId,
  HOUR,
  type ResponseError,
  toResponseError,
  unique,
} from '@terros/common'

type UseDispositionsSearchResult = {
  data: DispositionData[]
  isLoading: boolean
  error?: ResponseError
}
export const useDispositionsSearch = (dispositionIds: DispositionId[]): UseDispositionsSearchResult => {
  const serverRequest = useServerRequest<DispositionGetInput, DispositionGetSuccess>('/disposition/get')

  return useQueries({
    queries: unique(dispositionIds).map((dispositionId) => {
      return {
        queryKey: dispositionKey(dispositionId),
        queryFn: async () => {
          const res = await serverRequest({ dispositionId })
          return res.disposition
        },
        staleTime: HOUR,
        gcTime: DAY,
        retry: false,
      }
    }),
    combine: (results) => {
      const error = results.find((result) => result.error)

      return {
        data: results.map((result) => result.data).filter((disposition) => disposition !== undefined),
        isLoading: results.some((result) => result.isLoading),
        error: error ? toResponseError(error) : undefined,
      }
    },
  })
}
